var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { slot: "detail", model: _vm.model },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                { attrs: { disabled: _vm.formDisabled } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.processNo"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "", disabled: true },
                            model: {
                              value: _vm.model.processNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "processNo", $$v)
                              },
                              expression: "model.processNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["eletronicSigned.startTime"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: true,
                              format: "YYYY-MM-DD HH:mm:ss",
                              getCalendarContainer: function(node) {
                                return node.parentNode
                              }
                            },
                            model: {
                              value: _vm.model.startTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "startTime", $$v)
                              },
                              expression: "model.startTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    "tab-bar-style": {
                      marginBottom: "12px",
                      paddingLeft: "16px"
                    }
                  },
                  on: { change: _vm.changeTabs }
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll;"
                            : "max-height: 45vh;overflow:scroll;"
                          : _vm.setEdit === true
                          ? "max-height: 54vh;overflow:scroll;"
                          : "max-height: 65vh;overflow:scroll;",
                      attrs: { loading: "true", tab: _vm.model.processName }
                    },
                    [
                      _c("details-modal", {
                        attrs: {
                          "form-id": _vm.model.formId,
                          "form-no": _vm.model.businessFormNo
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "3",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 45vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: { tab: _vm.language["eletronicSigned.signList"] }
                    },
                    [
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signList"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              rowKey: "id",
                              columns: _vm.columns,
                              pagination: false,
                              dataSource: _vm.dataSource,
                              loading: _vm.loading
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signPerson"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              columns: _vm.approverColumns,
                              size: "middle",
                              "data-source": _vm.approverData,
                              pagination: false,
                              loading: _vm.loading
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "4",
                      style:
                        _vm.innerFullscreen === false
                          ? _vm.setEdit === true
                            ? "max-height: 32vh;overflow:scroll"
                            : "max-height: 45vh;overflow:scroll"
                          : _vm.setEdit === true
                          ? "max-height: 45vh;overflow:scroll"
                          : "max-height: 65vh;overflow:scroll",
                      attrs: {
                        tab: _vm.language["eletronicSigned.processChart"]
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "10px",
                            "overflow-x": "scroll"
                          }
                        },
                        [
                          _c(
                            "a-steps",
                            { attrs: { size: "small" } },
                            [
                              _c(
                                "a-step",
                                {
                                  attrs: {
                                    title:
                                      _vm.language["bpm.sign.startTaskName"],
                                    status: "finish"
                                  }
                                },
                                [
                                  _c("template", { slot: "description" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: { color: "green" },
                                        attrs: { slot: "title" },
                                        slot: "title"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.model.createUserRealname)
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                2
                              ),
                              _vm._l(_vm.chartList, function(item, index) {
                                return _c(
                                  "a-step",
                                  {
                                    key: index,
                                    attrs: {
                                      title: item.taskName,
                                      status:
                                        item.taskStatus == "Ready"
                                          ? "process"
                                          : item.taskStatus == "Rejected"
                                          ? "error"
                                          : item.taskStatus == "Completed"
                                          ? "finish"
                                          : "wait"
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "description" },
                                      _vm._l(item.signUsers, function(
                                        signUser,
                                        i
                                      ) {
                                        return _c(
                                          "p",
                                          {
                                            key: i,
                                            style:
                                              _vm.model.processStatus ==
                                              "Cancelled"
                                                ? signUser.isSign == 1
                                                  ? "color:green"
                                                  : ""
                                                : signUser.isSign == 1
                                                ? "color:green"
                                                : signUser.ready
                                                ? "color:red"
                                                : "",
                                            attrs: { slot: "title" },
                                            slot: "title"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(signUser.userCodeName) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  2
                                )
                              }),
                              _c("a-step", {
                                attrs: {
                                  title: _vm.language["bpm.sign.endTaskName"],
                                  description: "",
                                  status:
                                    _vm.model.processStatus == "Completed"
                                      ? "finish"
                                      : "wait"
                                }
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.setEdit
                ? _c(
                    "a-card",
                    {
                      attrs: {
                        bordered: false,
                        title: _vm.language["eletronicSigned.signOpinion"]
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "a-row",
                            [
                              _c("a-textarea", {
                                attrs: { maxlength: "1000" },
                                model: {
                                  value: _vm.model.comments,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "comments", $$v)
                                  },
                                  expression: "model.comments"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "center" } },
                            [
                              _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    color: "blue",
                                    right: "20px",
                                    "padding-left": "30px",
                                    "padding-right": "30px"
                                  },
                                  on: { click: _vm.agree }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["eletronicSigned.agree"]
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    color: "red",
                                    left: "20px",
                                    "padding-left": "30px",
                                    "padding-right": "30px"
                                  },
                                  on: { click: _vm.reject }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.language["eletronicSigned.reject"]
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }